import { PAGE_TYPE } from "@/meta/common";
import { RouteRecordRaw } from "vue-router";
/**
 * 仓储管理
 */
export const storageRouter: RouteRecordRaw[] = [
    {
        path: "storage",
        name: "StorageManagement",
        component: () => import("@/views/layouts/index.vue"),
        redirect: "/storage/inventoryQuery",
        meta: {
            title: "库存管理"
        },
        children: [
            {
                path: "inventoryQuery",
                name: "InventoryQuery",
                component: () => import("@/views/pages/storageManagement/inventoryQuery/index.vue"),
                meta: {
                    title: "库存查询",
                    pageType: PAGE_TYPE.LIST.code,
                    isNotShowHeader: true,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "inbound",
                name: "Inbound",
                component: () => import("@/views/pages/storageManagement/inboundManagement/index.vue"),
                meta: {
                    title: "入库管理",
                    activeMenu: "Inbound",
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.LIST.code,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "inbound/detail",
                name: "InboundDetail",
                component: () => import("@/views/pages/storageManagement/inboundManagement/detail.vue"),
                meta: {
                    title: "入库单详情",
                    activeMenu: "Inbound",
                    isNotShowHeader: true,
                    hidden: true,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "inbound/add",
                name: "InboundAdd",
                component: () => import("@/views/pages/storageManagement/inboundManagement/form.vue"),
                meta: {
                    title: "新增入库单",
                    activeMenu: "Inbound",
                    isNotShowHeader: true,
                    hidden: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "inbound/edit",
                name: "InboundEdit",
                component: () => import("@/views/pages/storageManagement/inboundManagement/form.vue"),
                meta: {
                    title: "修改入库单",
                    activeMenu: "Inbound",
                    isNotShowHeader: true,
                    hidden: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "outbound",
                name: "Outbound",
                component: () => import("@/views/pages/storageManagement/outboundManagement/index.vue"),
                meta: {
                    title: "出库管理",
                    isNotShowHeader: true,
                    activeMenu: "Outbound",
                    pageType: PAGE_TYPE.LIST.code,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "outbound/detail",
                name: "OutboundDetail",
                component: () => import("@/views/pages/storageManagement/outboundManagement/detail.vue"),
                meta: {
                    title: "出库单详情",
                    activeMenu: "Outbound",
                    isNotShowHeader: true,
                    hidden: true,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "outbound/add",
                name: "OutboundAdd",
                component: () => import("@/views/pages/storageManagement/outboundManagement/form.vue"),
                meta: {
                    title: "新增出库单",
                    activeMenu: "Outbound",
                    isNotShowHeader: true,
                    hidden: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "outbound/edit",
                name: "OutboundEdit",
                component: () => import("@/views/pages/storageManagement/outboundManagement/form.vue"),
                meta: {
                    title: "修改出库单",
                    activeMenu: "Outbound",
                    isNotShowHeader: true,
                    hidden: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "stockTake",
                name: "StockTake",
                component: () => import("@/views/pages/storageManagement/stocktakeManagement/index.vue"),
                meta: {
                    title: "盘点管理",
                    activeMenu: "StockTake",
                    pageType: PAGE_TYPE.LIST.code,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "stockTake/detail",
                name: "StockTakeDetail",
                component: () => import("@/views/pages/storageManagement/stocktakeManagement/detail.vue"),
                meta: {
                    title: "盘点详情",
                    activeMenu: "StockTake",
                    isNotShowHeader: true,
                    hidden: true,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "stockTake/add",
                name: "StockTakeAdd",
                component: () => import("@/views/pages/storageManagement/stocktakeManagement/form.vue"),
                meta: {
                    title: "新增盘点",
                    activeMenu: "StockTake",
                    isNotShowHeader: true,
                    hidden: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "stockTake/edit",
                name: "StockTakeEdit",
                component: () => import("@/views/pages/storageManagement/stocktakeManagement/form.vue"),
                meta: {
                    title: "修改盘点",
                    activeMenu: "StockTake",
                    isNotShowHeader: true,
                    hidden: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "inventoryRandomInspection",
                name: "InventoryRandomInspection",
                component: () => import("@/views/pages/storageManagement/inventoryRandomInspection/index.vue"),
                meta: {
                    title: "库存抽检",
                    pageType: PAGE_TYPE.LIST.code,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "inventoryRandomInspection/detail/:id",
                name: "InventoryRandomInspectionDetail",
                component: () => import("@/views/pages/storageManagement/inventoryRandomInspection/detail.vue"),
                meta: {
                    title: "抽检详情",
                    activeMenu: "InventoryRandomInspection",
                    pageType: PAGE_TYPE.LOG.code,
                    hidden: true,
                    isNotShowHeader: true,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "inventoryRandomInspection/add",
                name: "InventoryRandomInspectionAdd",
                component: () => import("@/views/pages/storageManagement/inventoryRandomInspection/form.vue"),
                meta: {
                    title: "新增抽检单",
                    activeMenu: "InventoryRandomInspection",
                    isNotShowHeader: true,
                    hidden: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "inventoryRandomInspection/edit/:id",
                name: "InventoryRandomInspectionEdit",
                component: () => import("@/views/pages/storageManagement/inventoryRandomInspection/form.vue"),
                meta: {
                    title: "修改抽检单",
                    activeMenu: "InventoryRandomInspection",
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    hidden: true,
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "pledge",
                name: "PledgeManagement",
                component: () => import("@/views/pages/storageManagement/pledgeManagement/index.vue"),
                meta: {
                    title: "质押管理",
                    pageType: PAGE_TYPE.LIST.code,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "pledge/detail/:id",
                name: "PledgeDetail",
                component: () => import("@/views/pages/storageManagement/pledgeManagement/detail.vue"),
                meta: {
                    title: "质押详情",
                    activeMenu: "PledgeManagement",
                    pageType: PAGE_TYPE.LOG.code,
                    hidden: true,
                    isNotShowHeader: true,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "pledge/add",
                name: "PledgeAdd",
                component: () => import("@/views/pages/storageManagement/pledgeManagement/add.vue"),
                meta: {
                    title: "新增质押",
                    activeMenu: "PledgeManagement",
                    isNotShowHeader: true,
                    hidden: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "pledge/edit/:id",
                name: "PledgeEdit",
                component: () => import("@/views/pages/storageManagement/pledgeManagement/add.vue"),
                meta: {
                    title: "变更质押",
                    activeMenu: "PledgeManagement",
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    hidden: true,
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "warehouse/add",
                name: "WarehouseAdd",
                component: () => import("@/views/pages/storageManagement/warehouseManagement/add.vue"),
                meta: {
                    title: "新增仓库",
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    hidden: true,
                    activeMenu: "WarehouseManagement",
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "warehouse/edit/:id",
                name: "WarehouseEdit",
                component: () => import("@/views/pages/storageManagement/warehouseManagement/add.vue"),
                meta: {
                    title: "编辑仓库",
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    hidden: true,
                    activeMenu: "WarehouseManagement",
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "warehouse/detail/:id",
                name: "WarehouseDetail",
                component: () => import("@/views/pages/storageManagement/warehouseManagement/detail.vue"),
                meta: {
                    title: "仓库详情",
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.LOG.code,
                    hidden: true,
                    activeMenu: "WarehouseManagement",
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "storageInception",
                name: "StorageInception",
                component: () => import("@/views/pages/storageManagement/storageInception/index.vue"),
                meta: {
                    title: "仓储期初",
                    pageType: PAGE_TYPE.LIST.code,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "storageInception/detail/:id",
                name: "StorageInceptionDetail",
                component: () => import("@/views/pages/storageManagement/storageInception/detail.vue"),
                meta: {
                    title: "仓储期初详情",
                    activeMenu: "StorageInception",
                    pageType: PAGE_TYPE.LOG.code,
                    hidden: true,
                    isNotShowHeader: true,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "storageInception/add",
                name: "StorageInceptionAdd",
                component: () => import("@/views/pages/storageManagement/storageInception/add.vue"),
                meta: {
                    title: "新增仓储期初",
                    activeMenu: "StorageInception",
                    isNotShowHeader: true,
                    hidden: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "storageInception/edit/:id",
                name: "StorageInceptionEdit",
                component: () => import("@/views/pages/storageManagement/storageInception/add.vue"),
                meta: {
                    title: "修改仓储期初",
                    activeMenu: "StorageInception",
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    hidden: true,
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            }
        ]
    }
];
